import { useContext } from 'react';

import { QSetReviewTaskCreationContext } from './qset-review-task-creation-provider';

export function useQSetReviewTaskCreation() {
  const context = useContext(QSetReviewTaskCreationContext);

  if (!context) {
    throw new Error(
      'useQSetReviewTaskCreation must be used within a QSetReviewTaskCreationProvider',
    );
  }

  return context;
}
